import {
  IsEmail,
  IsPhoneNumber,
  IsNotEmpty,
  IsString,
  IsOptional,
  IsDate,
  IsDateString
} from 'class-validator';
import { IBaseResponse } from './base-response.dto';

export interface IPatient {
  _id?: any;
  leadId?: string;
  emrId?: string;
  firstName: string;
  lastName: string;
  dob: Date;
  email: string;
  phone: string;
  organization: string;
  notes?: string;
  source?: string;
  address?: {
    address_1?: string;
    address_2?: string;
    city?: string;
    postal?: string;
    province?: string;
    country?: string;
  };
  healthCard?: {
    number: string;
    version?: string;
    province?: string;
    expDate?: string;
    effDate?: string;
  };
  meta?: any;
  riskRating?: string;
}

/* -------------------------------------------------------------------------- */
/*                               Create new Patient                           */
/* -------------------------------------------------------------------------- */

export interface CreatePatientResponse extends IBaseResponse {
  patient: IPatient;
}

/* -------------------------------------------------------------------------- */
/*                                  Get Patients                                 */
/* -------------------------------------------------------------------------- */
export class GetPatientsDto {}
/* -------------------------------------------------------------------------- */
/*                               Update Patients                              */
/* -------------------------------------------------------------------------- */
export class UpdatePatientDto {}

export type GetPatientsResponse = IPatient[];

/* -------------------------------------------------------------------------- */
/*                           checkIfDemographicExist                          */
/* -------------------------------------------------------------------------- */
